

export default function setupAnimationUtilities(){
    const triggerSettings = {
      start: "top 75%",
      //markers: true
    }
  
    const dirMappings = [
      {
        name: "",
        settings: {}
      },
      {
        name: "--up",
        settings: {y: 20}
      },
      {
        name: "--down",
        settings: {y: -20}
      },
      {
        name: "--left",
        settings: {x: 20}
      },
      {
        name: "--right",
        settings: {x: -20}
      },
    ]
  
    dirMappings.forEach(mapping => {
  
      const {name, settings} = mapping
  
      gsap.utils.toArray(`.gsap-stagger${name}`).forEach(item => {
        gsap.from(item.children, {
          autoAlpha: 0, 
          stagger: 0.1,
          ...settings,
          scrollTrigger: {
            trigger: item,
            ...triggerSettings
          }
        })
      })
  
      gsap.utils.toArray(`.gsap-fade${name}`).forEach(item => {
        gsap.from(item, {
          autoAlpha: 0, 
          ...settings,
          scrollTrigger: {
            trigger: item,
            ...triggerSettings
          }
        })
      })
    })

    gsap.utils.toArray('.wp-block-cover > img').forEach(item => {
      gsap.from(item, {
        autoAlpha: 0,
        scrollTrigger: {
          trigger: item,
          ...triggerSettings
        }
      })
    })
  }